import { Routes, Route } from 'react-router-dom';
import './App.css';
import Admin from './pages/admin/admin.component';
import Home from './pages/home/home.component';

const App = () => {
  return (
    <Routes>
      <Route path='/' element={<Home />} />
      <Route path='admin' element={<Admin />} />
    </Routes>
  );
};

export default App;
